export const appsConfig = {
  allowTwilioAccountChange: process.env.REACT_APP_ALLOW_TWILIO_ACCOUNT_CHANGE === 'true',
};
